import React, { useState } from 'react';
import HeaderMenuButtonV2 from '../HeaderMenuButton/HeaderMenuButtonV2';
import { Box, Popover, Tabs, Tab } from '@mui/material';
import { Troubleshoot } from '@mui/icons-material';
import ViewInfoPanel from './ViewInfoPanel';
import FeatureFlagPanel from './FeatureFlagPanel';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
  id: string;
};

function TabPanel({ children, index, value, id }: TabPanelProps) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${id}`}
      aria-labelledby={`tab-${id}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function HopviewButton() {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [tab, setTab] = useState(0);

  return (
    <>
      <HeaderMenuButtonV2
        title='Hopview (INTERNAL)'
        variant='dark'
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Troubleshoot />
      </HeaderMenuButtonV2>
      <Popover
        id='hopview-menu'
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={() => setAnchorEl(null)}
      >
        <Tabs
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          variant='fullWidth'
        >
          <Tab
            label='View info'
            id='tab-view-info'
            aria-controls='tabpanel-view-info'
          />
          <Tab
            label='Feature flags'
            id='tab-feature-flags'
            aria-controls='tabpanel-feature-flags'
          />
        </Tabs>
        <TabPanel index={0} value={tab} id='view-info'>
          <ViewInfoPanel />
        </TabPanel>
        <TabPanel index={1} value={tab} id='feature-flags'>
          <FeatureFlagPanel />
        </TabPanel>
      </Popover>
    </>
  );
}
